import { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaskedTextInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    masking,
    ...rest
  } = props;
  if (masking) {
    return /*#__PURE__*/_jsx(MaskedInput, {
      ...rest,
      mask: masking.mask,
      guide: masking.guide,
      pipe: masking.pipe
    });
  }
  return null;
});
MaskedTextInput.displayName = 'MaskedTextInput';